// export const adminBaseUrl = "https://api.emadiappraisals.com/api/v1"; //hosted
export const adminBaseUrl = "https://appraiser-backend-qn4z.onrender.com/api/v1"; //local

// export const publicBaseUrl = "https://api.emadiappraisals.com/api/v1"; //hosted
export const publicBaseUrl = "https://appraiser-backend-qn4z.onrender.com/api/v1"; //local

// export const socketUrl = "https://appraiser-socket.onrender.com";
export const socketUrl = "https://socket.emadiappraisals.com"

export const categoryBaseUrl = publicBaseUrl + "/category";

export const productBaseUrl = publicBaseUrl + "/product";
